import { IApplicationState } from '../../types/redux';
import { TUser } from '../../types/user';

export const selectFirstUserPhone = ({ user }: IApplicationState): string | null =>
  (user.isAuthenticated && user.phones && user.phones[0]) || null;

export const selectUserEmail = ({ user }: IApplicationState): string | null =>
  (user.isAuthenticated && user.email) || null;

export const selectUser = ({ user }: IApplicationState): TUser => user;

export const selectUserId = ({ user }: IApplicationState): number | null =>
  (user.isAuthenticated && user.userId) || null;

export function selectIsAuthenticated({ user }: IApplicationState) {
  return user.isAuthenticated;
}
